export default __webpack_public_path__ + "static/assets/ef6e99d45f9c5cd591db8fbf0c6d2f3e.png";